<div class="commission-page">
  <p-card styleClass="commission-settings-card">
    <ng-template pTemplate="header">
      <div class="header">
        <div class="title">
          <i class="pi pi-percentage"></i>
          <div>
            <h2>Paramètres de Commission</h2>
            <p>Même liste que la colonne « Commission » du tableau comparateur</p>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="content">
      <div class="single-block">
        <p class="single-hint">
          Ce réglage est <strong>le même</strong> que dans le comparateur santé : un taux au format
          <code>XX/XX</code>, enregistré dans ce navigateur et appliqué par défaut à toutes les lignes du tableau lors
          du chargement des résultats.
        </p>
        <div class="single-row">
          <p-dropdown
            [options]="unifiedOptions"
            [(ngModel)]="singleSelectedCode"
            (onChange)="onDropdownChange()"
            placeholder="Sélectionner un taux (ex. 40/10)"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            styleClass="w-full commission-single-dropdown"
            [filter]="true"
            filterBy="label,value"
            [showClear]="true"
          >
          </p-dropdown>
        </div>
        <p class="single-footnote">
          Enregistrement automatique après le choix (stockage local, identique au tableau CAS).
        </p>
      </div>
    </div>
  </p-card>

  <p-toast></p-toast>
</div>
